export const toDecimalFractions = (num) => {
    let isNegativeNumber = num < 0;

    return (isNegativeNumber ? '-' : '') + String(Math.round(Math.abs(num))).replace(/(.)(?=(\d{3})+$)/g, '$1.');
};
